require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./breadcrumb"), require("./button"), require("./container"), require("./context"), require("./contextmenu"), require("./flexlayout"), require("./itemdnd"), require("./label"), require("./link"), require("./list"), require("./menu"), require("./progressindicator"), require("./svgicon"), require("./textinput"), require("./tile"), require("./toolbar"), require("./truncatedtext"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./breadcrumb", "./button", "./container", "./context", "./contextmenu", "./flexlayout", "./itemdnd", "./label", "./link", "./list", "./menu", "./progressindicator", "./svgicon", "./textinput", "./tile", "./toolbar", "./truncatedtext", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./breadcrumb"), require("./button"), require("./container"), require("./context"), require("./contextmenu"), require("./flexlayout"), require("./itemdnd"), require("./label"), require("./link"), require("./list"), require("./menu"), require("./progressindicator"), require("./svgicon"), require("./textinput"), require("./tile"), require("./toolbar"), require("./truncatedtext"), require("./utils")) : factory(root["./breadcrumb"], root["./button"], root["./container"], root["./context"], root["./contextmenu"], root["./flexlayout"], root["./itemdnd"], root["./label"], root["./link"], root["./list"], root["./menu"], root["./progressindicator"], root["./svgicon"], root["./textinput"], root["./tile"], root["./toolbar"], root["./truncatedtext"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__68393__, __WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__32299__, __WEBPACK_EXTERNAL_MODULE__14935__, __WEBPACK_EXTERNAL_MODULE__66740__, __WEBPACK_EXTERNAL_MODULE__77765__, __WEBPACK_EXTERNAL_MODULE__40772__, __WEBPACK_EXTERNAL_MODULE__37394__, __WEBPACK_EXTERNAL_MODULE__85717__, __WEBPACK_EXTERNAL_MODULE__70309__, __WEBPACK_EXTERNAL_MODULE__93158__, __WEBPACK_EXTERNAL_MODULE__3142__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__73346__, __WEBPACK_EXTERNAL_MODULE__42327__, __WEBPACK_EXTERNAL_MODULE__84368__, __WEBPACK_EXTERNAL_MODULE__47511__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[7217],{

/***/ 45533:
/***/ ((module) => {

var amdi18n={"__root":{"defaultFolder":"Default Folder","placeholder":"Untitled Folder"},"__cs":{"defaultFolder":"Výchozí složka","placeholder":"Složka bez názvu"},"__da":{"defaultFolder":"Standardfolder","placeholder":"Folder uden navn"},"__de":{"defaultFolder":"Standardordner","placeholder":"Nicht benannter Ordner"},"__es":{"defaultFolder":"Carpeta predeterminada","placeholder":"Carpeta sin título"},"__fi":{"defaultFolder":"Oletuskansio","placeholder":"Nimetön kansio"},"__fr":{"defaultFolder":"Dossier par défaut","placeholder":"Dossier sans titre"},"__hr":{"defaultFolder":"Defaultni folder","placeholder":"Neimenovani folder"},"__hu":{"defaultFolder":"Alapértelmezett mappa","placeholder":"Névtelen mappa"},"__it":{"defaultFolder":"Cartella predefinita","placeholder":"Cartella senza titolo "},"__ja":{"defaultFolder":"デフォルトのフォルダー","placeholder":"無題フォルダー"},"__kk":{"defaultFolder":"Әдепкі қалта","placeholder":"Аты жоқ қалта"},"__ko":{"defaultFolder":"기본 폴더","placeholder":"제목 없는 폴더"},"__nb":{"defaultFolder":"Standardmappe","placeholder":"Mappe uten tittel"},"__nl":{"defaultFolder":"Standaardmap","placeholder":"Naamloze map"},"__no":{"defaultFolder":"Standardmappe","placeholder":"Mappe uten tittel"},"__pl":{"defaultFolder":"Folder domyślny","placeholder":"Folder bez tytułu"},"__pt":{"defaultFolder":"Pasta padrão","placeholder":"Pasta sem título"},"__pt-br":{"defaultFolder":"Pasta padrão","placeholder":"Pasta sem título"},"__ro":{"defaultFolder":"Folder implicit","placeholder":"Folder fără titlu "},"__ru":{"defaultFolder":"Папка по умолчанию","placeholder":"Папка без имени"},"__sl":{"defaultFolder":"Privzeta mapa","placeholder":"Mapa brez naslova"},"__sv":{"defaultFolder":"Standardmapp","placeholder":"Namnlös mapp "},"__th":{"defaultFolder":"โฟลเดอร์ดีฟอลต์","placeholder":"โฟลเดอร์ที่ไม่มีชื่อ"},"__tr":{"defaultFolder":"Varsayılan Klasör","placeholder":"Adsız Klasör"},"__uk":{"defaultFolder":"Папка за замовчуванням","placeholder":"Папка без назви"},"__zh":{"defaultFolder":"缺省文件夹","placeholder":"未命名文件夹"},"__zh-cn":{"defaultFolder":"缺省文件夹","placeholder":"未命名文件夹"},"__zh-hk":{"defaultFolder":"預設資料夾","placeholder":"未命名的資料夾"},"__zh-mo":{"defaultFolder":"預設資料夾","placeholder":"未命名的資料夾"},"__zh-sg":{"defaultFolder":"缺省文件夹","placeholder":"未命名文件夹"},"__zh-tw":{"defaultFolder":"預設資料夾","placeholder":"未命名的資料夾"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 89669:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _breadcrumb = _interopRequireDefault(__webpack_require__(68393));
var _toolbar = _interopRequireDefault(__webpack_require__(84368));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _link = _interopRequireDefault(__webpack_require__(85717));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _utils = __webpack_require__(78815);
var _filter_ = _interopRequireDefault(__webpack_require__(95333));
var _filterApplied_ = _interopRequireDefault(__webpack_require__(20361));
var _add_ = _interopRequireDefault(__webpack_require__(32737));
var _overflowMenuHorizontal_ = _interopRequireDefault(__webpack_require__(16346));
var _arrowsVertical_ = _interopRequireDefault(__webpack_require__(75924));
var _search_ = _interopRequireDefault(__webpack_require__(76214));
var _settingsAdjust_ = _interopRequireDefault(__webpack_require__(5158));
var _StringResource = _interopRequireDefault(__webpack_require__(32890));
var _DataView = _interopRequireDefault(__webpack_require__(20069));
var _DataViewItem = _interopRequireDefault(__webpack_require__(17490));
var _errorboundary = _interopRequireDefault(__webpack_require__(30987));
var _Navigator = _interopRequireDefault(__webpack_require__(32547));
var _class, _dec, _class2, _class3;
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getString(value) {
  return _StringResource.default.get(value);
}
const navigatorClassName = _Navigator.default.navigatorClassName.replace(/"/g, '');
const DATAVIEW_HEADER_HEIGHT = 48;
const {
  sanitize
} = _utils.propsUtils;
function getToolbarButton(icon, props) {
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    hasIconOnly: true,
    kind: "ghost",
    size: "small",
    renderIcon: iconProps => /*#__PURE__*/_react.default.createElement(_svgicon.default, (0, _extends2.default)({
      icon: icon
    }, iconProps))
  }, props));
}
_toolbar.default.Add = class Add extends _react.Component {
  render() {
    return getToolbarButton(_add_.default, this.props);
  }
};
_toolbar.default.Filter = (_class = class Filter extends _react.Component {
  render() {
    const {
      isFilterDirty,
      ...otherProps
    } = this.props;
    const icon = isFilterDirty ? _filterApplied_.default : _filter_.default;
    return getToolbarButton(icon, otherProps);
  }
}, (0, _defineProperty2.default)(_class, "propTypes", {
  isFilterDirty: _propTypes.default.bool
}), _class);
_toolbar.default.Sort = class Sort extends _react.Component {
  render() {
    return getToolbarButton(_arrowsVertical_.default, this.props);
  }
};
_toolbar.default.Configure = class Configure extends _react.Component {
  render() {
    return getToolbarButton(_settingsAdjust_.default, this.props);
  }
};
_toolbar.default.Search = class Search extends _react.Component {
  render() {
    return getToolbarButton(_search_.default, this.props);
  }
};
_toolbar.default.Menu = class Menu extends _react.Component {
  render() {
    return getToolbarButton(_overflowMenuHorizontal_.default, this.props);
  }
};
_toolbar.default.ToolbarLink = class ToolbarLink extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_link.default, this.props);
  }
};
let Navigator = exports["default"] = (_dec = (0, _errorboundary.default)(), _dec(_class2 = (_class3 = class Navigator extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_revertSelection", () => {
      this.props.onSelectionChange({});
    });
    (0, _defineProperty2.default)(this, "_renderToolbar", () => this.props.toolbarRenderer && this.props.toolbarRenderer(_toolbar.default));
    (0, _defineProperty2.default)(this, "_renderBreadcrumb", () => {
      const {
        hideBackButton,
        ancestors,
        textDir
      } = this.props;
      if (!ancestors) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_breadcrumb.default, {
        size: "small",
        noTrailingSlash: true,
        "data-tid": "ba-common-navigator__breadcrumb",
        hideBackButton: hideBackButton,
        textDir: textDir,
        ancestors: ancestors,
        historyCallback: this._onNavBack,
        navCallback: this._nav
      });
    });
    (0, _defineProperty2.default)(this, "_renderHeader", () => {
      const {
        showBreadCrumb
      } = this.props;
      if (!this._renderBreadcrumb() && !this._renderToolbar()) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `${navigatorClassName}__header-wrapper`
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: `${navigatorClassName}__header`
      }, showBreadCrumb && this._renderBreadcrumb(), this._renderToolbar()));
    });
    (0, _defineProperty2.default)(this, "_itemsRenderer", (items, ref) => {
      const {
        onSaveNewFile,
        dismissCreateFile,
        action,
        files,
        newItemPlaceholder
      } = this.props;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: ref
      }, action && action.type === 'CREATE' && /*#__PURE__*/_react.default.createElement(_DataViewItem.default, {
        length: files.length + 1,
        index: -1
      }, /*#__PURE__*/_react.default.createElement(_DataViewItem.default.Input, {
        icon: action.icon,
        value: getString('defaultFolder'),
        onSaveNewFile: onSaveNewFile,
        dismissCreateFile: dismissCreateFile,
        fileType: action.value,
        placeholder: newItemPlaceholder
      })), items);
    });
    (0, _defineProperty2.default)(this, "_", void 0);
    (0, _defineProperty2.default)(this, "_renderDataView", () => {
      const {
        // bool
        tileView,
        loaded,
        grouped,
        scrollToHideDataViewHeader,
        toSelectionMap,
        // array
        files,
        itemMenuContent,
        // obj
        selectedItems,
        emptyState,
        dataViewExtraOptions,
        // string
        selectionMode,
        // cb
        getMoreData,
        onSelectionChange,
        onActiveChange,
        onItemMenu,
        onMenuClick,
        groupBy,
        // hook
        dataViewRenderer,
        getId
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_DataView.default, (0, _extends2.default)({}, dataViewExtraOptions, {
        // bool
        tileView: tileView,
        loaded: loaded,
        grouped: grouped,
        groupBy: groupBy,
        toSelectionMap: toSelectionMap
        // array
        ,
        data: files,
        itemMenuContent: itemMenuContent
        // obj
        ,
        selectedItems: selectedItems,
        emptyState: emptyState
        // string
        ,
        selectionMode: selectionMode
        // cb
        ,
        getMoreData: getMoreData,
        onSelectionChange: onSelectionChange,
        onActiveChange: onActiveChange,
        onItemMenu: onItemMenu,
        onMenuClick: onMenuClick,
        dataViewRenderer: dataViewRenderer,
        itemsRenderer: this._itemsRenderer,
        onWheel: scrollToHideDataViewHeader ? this._onWheel : undefined,
        scrollToHideDataViewHeader: scrollToHideDataViewHeader,
        getId: getId
      }));
    });
    (0, _defineProperty2.default)(this, "_onDownWards", e => {
      const {
        scrollTop
      } = e.currentTarget;
      const {
        style
      } = this._dataviewHeader;
      style.marginTop = `${-Math.min(scrollTop, DATAVIEW_HEADER_HEIGHT)}px`;
    });
    (0, _defineProperty2.default)(this, "_onUpWards", () => {
      const {
        style
      } = this._dataviewHeader;
      style.marginTop = '0px';
    });
    (0, _defineProperty2.default)(this, "_onWheel", e => {
      if (e.deltaY > 0) {
        this._onDownWards(e);
      } else {
        this._onUpWards();
      }
    });
    (0, _defineProperty2.default)(this, "_onNavBack", () => {
      const {
        onNavBack
      } = this.props;
      onNavBack();
    });
    (0, _defineProperty2.default)(this, "_nav", index => {
      const {
        onNav
      } = this.props;
      onNav(index);
    });
    (0, _defineProperty2.default)(this, "_dataviewHeaderRef", ref => {
      this._dataviewHeader = ref;
    });
  }
  componentWillReceiveProps(newProps) {
    const {
      ancestors
    } = this.props;
    if (!ancestors || !newProps.ancestors) return;
    if (ancestors.length !== newProps.ancestors.length) {
      this._revertSelection();
    }
  }
  _renderDataViewFooter() {
    const {
      dataViewFooterRenderer
    } = this.props;
    if (dataViewFooterRenderer) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `${navigatorClassName}__dataview-footer`
      }, dataViewFooterRenderer());
    }
    return null;
  }
  _renderDataViewHeader() {
    const {
      dataViewHeaderRenderer,
      scrollToHideDataViewHeader
    } = this.props;
    const dataViewHeaderClassName = (0, _utils.classnames)(`${navigatorClassName}__dataview-header`, {
      scrollable: scrollToHideDataViewHeader
    });
    if (dataViewHeaderRenderer) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: dataViewHeaderClassName,
        ref: this._dataviewHeaderRef
      }, dataViewHeaderRenderer());
    }
    return null;
  }
  render() {
    const {
      height,
      width,
      className,
      style,
      ancestors,
      toolbarRenderer,
      ...others
    } = this.props;
    const styles = {
      width,
      height,
      ...style
    };
    const mainClassName = (0, _utils.classnames)(`${navigatorClassName}__main`, {
      noHeader: (!ancestors || ancestors.length === 0) && !toolbarRenderer
    });
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, Navigator), {
      className: `${navigatorClassName} ${className}`,
      style: styles
    }), this._renderHeader(), /*#__PURE__*/_react.default.createElement("div", {
      className: mainClassName
    }, this._renderDataViewHeader(), this._renderDataView(), this._renderDataViewFooter()));
  }
}, (0, _defineProperty2.default)(_class3, "propTypes", {
  /** Array of files displayed in the navigator list */
  files: _propTypes.default.array.isRequired,
  /** The items in the navigator menu that are selected */
  selectedItems: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.number]).isRequired,
  /** Width of the navigator */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Height of the navigator */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Controls the spinner gif visibility */
  loaded: _propTypes.default.bool,
  /** Controls the visibility of the back button */
  hideBackButton: _propTypes.default.bool,
  /** Allows for grouping of list items */
  grouped: _propTypes.default.bool,
  /** Hides data view header on scroll */
  scrollToHideDataViewHeader: _propTypes.default.bool,
  /** Displays items in a tile view */
  tileView: _propTypes.default.bool,
  /** Ancestors of current data view */
  ancestors: _propTypes.default.array,
  /** List of items in the context menu */
  itemMenuContent: _propTypes.default.array,
  /** Child element inside the navigator */
  children: _propTypes.default.element,
  /** Extra functionality for file interaction */
  action: _propTypes.default.object,
  /** Specifies what is displayed when there is no content */
  emptyState: _propTypes.default.shape({
    icon: _propTypes.default.object,
    label: _propTypes.default.string
  }),
  /** Callback for navigating through breadcrumb */
  onNav: _propTypes.default.func,
  /** Callback for navigating back through breadcrumb */
  onNavBack: _propTypes.default.func,
  /** Loads more data for infinite scroll */
  getMoreData: _propTypes.default.func,
  /** Handler for adding a folder */
  onAddFolder: _propTypes.default.func,
  /** Handler for creating a new file */
  onSaveNewFile: _propTypes.default.func,
  /** Handler for changing item selection */
  onSelectionChange: _propTypes.default.func,
  /** Handler when esc key is pressed during new file creation */
  dismissCreateFile: _propTypes.default.func,
  /** Callback for clicking a context menu item */
  onItemMenu: _propTypes.default.func,
  /** Renders the data view */
  dataViewRenderer: _propTypes.default.func.isRequired,
  /** Renders the header */
  dataViewHeaderRenderer: _propTypes.default.func,
  /** Renders the footer */
  dataViewFooterRenderer: _propTypes.default.func,
  /** Renders the toolbar */
  toolbarRenderer: _propTypes.default.func,
  /** Handler for changing active item */
  onActiveChange: _propTypes.default.func,
  /** Callback for clicking ... on a list item to open a context menu  */
  onMenuClick: _propTypes.default.func,
  /** Specifies how to group items */
  groupBy: _propTypes.default.func,
  /** Allow selection to be based on id rather than index */
  getId: _propTypes.default.func,
  /** Specifies how many items can be selected at a time */
  selectionMode: _propTypes.default.oneOf(['none', 'disabled', 'single', 'multi']),
  /** Custom class name */
  className: _propTypes.default.string,
  /** Custom styles */
  style: _propTypes.default.object,
  /** Size of the breadcrumb */
  breadcrumbSize: _breadcrumb.default.propTypes.size,
  /** Extra data view options */
  dataViewExtraOptions: _propTypes.default.object,
  /** Flag to make selected items an object */
  toSelectionMap: _propTypes.default.bool,
  /** Direction of text */
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  /** Place holder text for new items input box */
  newItemPlaceholder: _propTypes.default.string,
  /** Show/hide breadcrumb in header */
  showBreadCrumb: _propTypes.default.bool
}), (0, _defineProperty2.default)(_class3, "defaultProps", {
  height: '100%',
  breadcrumbSize: 'small',
  onNav: () => {},
  onNavBack: () => {},
  className: '',
  styles: {},
  dataViewExtraOptions: {},
  showBreadCrumb: true
}), _class3)) || _class2);

/***/ }),

/***/ 20069:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
exports.toIndexMap = toIndexMap;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _label = _interopRequireDefault(__webpack_require__(37394));
var _progressindicator = _interopRequireDefault(__webpack_require__(3142));
var _menu = _interopRequireDefault(__webpack_require__(93158));
var _contextmenu = _interopRequireDefault(__webpack_require__(66740));
var _list = _interopRequireWildcard(__webpack_require__(70309));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _DataView = _interopRequireDefault(__webpack_require__(68803));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const dataViewClassName = _DataView.default.dataView.replace(/"/g, '');
const {
  groupBy,
  findIndex,
  toPairs
} = _utils.lodash;
const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
function toIndexMap(prevData, newData) {
  const map = {};
  newData.forEach((m, index) => {
    map[index] = findIndex(prevData, _ref => {
      let {
        id
      } = _ref;
      return id === newData[index].id;
    });
  });
  return map;
}
class DataView extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {});
    (0, _defineProperty2.default)(this, "_itemRenderer", (index, props) => {
      const Item = _react.default.cloneElement(this.props.dataViewRenderer(index, props), {
        // extra props...
      });
      return Item;
    });
    (0, _defineProperty2.default)(this, "_renderEmptyState", () => {
      const {
        emptyState
      } = this.props;
      const {
        icon,
        label
      } = emptyState;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-tid": "ba-data-view__empty-state",
        className: `${dataViewClassName}__empty-state`
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: `${dataViewClassName}__empty-state-container`
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: `${dataViewClassName}__empty-state-icon`
      }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        iconId: icon.id,
        size: "xlarge"
      })), label));
    });
    (0, _defineProperty2.default)(this, "zip", (inputEntries, zipBy) => {
      const output = {};
      inputEntries.forEach(entry => {
        const [label, data] = entry;
        let newValue;
        const newLabel = zipBy(label);
        if (!output[newLabel]) {
          newValue = [...data];
        } else {
          newValue = [...output[newLabel], ...data];
        }
        output[newLabel] = newValue;
      });
      return toPairs(output);
    });
    (0, _defineProperty2.default)(this, "_onSelectionChange", event => {
      const {
        onSelectionChange,
        grouped,
        selectionMode,
        data,
        selectedItems,
        toSelectionMap
      } = this.props;
      const isSingleMode = selectionMode === 'single';
      let selectedItem;
      if (isSingleMode) {
        selectedItem = _utils.listHelper.singleSelect(event, grouped ? this.groupedData : data, selectedItems, this._getId);
        if (toSelectionMap && selectedItem != null) {
          selectedItem = this._toObjectMap({
            [selectedItem]: true
          });
        }
      } else {
        selectedItem = _utils.listHelper.multiSelect(event, grouped ? this.groupedData : data, selectedItems, this._getId).selectedMap;
      }
      this.setState({
        selectedItem
      }, () => {
        onSelectionChange(selectedItem);
      });
    });
    (0, _defineProperty2.default)(this, "_getId", index => this.props.getId ? this.props.getId(this.props.grouped ? this.groupedData[index] : this.props.data[index], index) : index);
    (0, _defineProperty2.default)(this, "_isSelected", index => {
      const id = this._getId(index);
      const {
        selectionMode,
        selectedItems,
        toSelectionMap
      } = this.props;
      if (toSelectionMap) {
        return !!selectedItems[id];
      }
      const isSingleMode = selectionMode === 'single';
      if (isSingleMode) {
        return selectedItems === id;
      }
      return !!selectedItems[id];
    });
    (0, _defineProperty2.default)(this, "_getMoreData", () => {
      const {
        getMoreData,
        data
      } = this.props;
      getMoreData([...data].pop());
    });
    (0, _defineProperty2.default)(this, "_onMenuChange", (name, value) => {
      const {
        onItemMenu
      } = this.props;
      onItemMenu(this.state.menuTarget, value);
      this.setState({
        showMenu: false
      });
    });
    (0, _defineProperty2.default)(this, "_onActiveChange", _ref2 => {
      let {
        index
      } = _ref2;
      const {
        onActiveChange,
        data,
        grouped
      } = this.props;
      const activeItem = grouped ? this.groupedData[index] : data[index];
      onActiveChange && onActiveChange(activeItem);
    });
    (0, _defineProperty2.default)(this, "_renderList", () => {
      const {
        loaded,
        data,
        onItemMenu,
        onMenuClick,
        selectedItems,
        selectionMode,
        grouped,
        itemsRenderer,
        groupBy: _groupBy,
        tileView,
        ...others
      } = this.props;
      const listPassthroughProps = getInheritedProps(others, _list.default);
      let dataLength;
      let dataItemRenderer;
      if (grouped && data.length > 0) {
        this.groupedData = [];
        let groupedDataObj;
        if (!_groupBy) {
          groupedDataObj = toPairs(groupBy(data, 'type'));
        } else {
          groupedDataObj = _groupBy(type => toPairs(groupBy(data, type)), this.zip);
        }
        const groupedDataEntries = groupedDataObj;
        groupedDataEntries.forEach(entry => {
          const [label, dataArr] = entry;
          this.groupedData.push({
            gpLabel: label
          });
          this.groupedData = [...this.groupedData, ...dataArr];
        });
        const indexMap = toIndexMap(data, this.groupedData);
        dataLength = this.groupedData.length;
        dataItemRenderer = (index, props) => {
          const currItem = this.groupedData[index];
          if (currItem.gpLabel) {
            return /*#__PURE__*/_react.default.createElement(_list.ListItem, (0, _extends2.default)({}, props, {
              active: false,
              selected: false,
              onMenu: null,
              outerClassName: (0, _utils.classnames)('groupedLabel')
            }), /*#__PURE__*/_react.default.createElement(_label.default, {
              key: `label-${index}`,
              label: currItem.gpLabel,
              type: "caption",
              className: `${dataViewClassName}__groupedLabel`
            }));
          }
          return this._itemRenderer(indexMap[index], props);
        };
      } else {
        dataLength = data.length;
        dataItemRenderer = this._itemRenderer;
      }
      const onMenuProps = {};
      if (onItemMenu) {
        onMenuProps.onMenu = (x, y, e) => {
          this.setState(state => ({
            showMenu: true,
            clickTarget: e.target,
            menuTarget: state.selectedItem
          }));
        };
      } else if (onMenuClick) {
        onMenuProps.onMenu = (x, y, e) => {
          onMenuClick(x, y, e);
        };
      }
      if (loaded) {
        const classNames = (0, _utils.classnames)({
          multiSelecting: selectionMode !== 'single' && Object.keys(selectedItems).length > 1,
          tileView
        });
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_list.default, (0, _extends2.default)({
          "data-tid": "ba-common-data-view__list",
          className: classNames
        }, sanitize(others, DataView), listPassthroughProps, {
          listType: "simple",
          length: dataLength,
          itemRenderer: dataItemRenderer,
          itemsRenderer: itemsRenderer,
          onSelectionChange: this._onSelectionChange,
          onActiveChange: this._onActiveChange,
          getMoreData: this._getMoreData,
          isSelected: this._isSelected,
          selectionMode: selectionMode,
          onWheel: this.props.onWheel
        }, onMenuProps)), data.length === 0 && this._renderEmptyState());
      }
      return null;
    });
  }
  _toObjectMap(boolMap) {
    const data = this.props.grouped ? this.groupedData : this.props.data;
    return Object.keys(boolMap).reduce((map, id) => {
      if (boolMap[id]) {
        const item = data.find((obj, i) => String(this._getId(i)) === id);
        if (item) {
          map[id] = item;
        }
      }
      return map;
    }, {});
  }
  render() {
    const {
      loaded,
      itemMenuContent
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: dataViewClassName
    }, !loaded && /*#__PURE__*/_react.default.createElement("div", {
      "data-tid": "ba-dataview__loader",
      className: `${dataViewClassName}__loading`
    }, /*#__PURE__*/_react.default.createElement(_progressindicator.default, {
      size: "large",
      variant: "circle"
    })), this._renderList(), this.state.showMenu && /*#__PURE__*/_react.default.createElement(_contextmenu.default, {
      theme: true,
      placement: "bottomRight",
      triggerNode: this.state.clickTarget,
      domNodeToAttachTo: document.body,
      onChange: this._onMenuChange,
      onClose: () => this.setState({
        showMenu: false
      })
    }, /*#__PURE__*/_react.default.createElement(_menu.default, null, /*#__PURE__*/_react.default.createElement(_menu.default.List, {
      content: itemMenuContent,
      name: "itemMenu"
    }))));
  }
}
exports["default"] = DataView;
(0, _defineProperty2.default)(DataView, "propTypes", {
  ...sanitize(_list.default.propTypes, null, 'length', 'itemRenderer'),
  data: _propTypes.default.array.isRequired,
  itemMenuContent: _propTypes.default.array,
  loaded: _propTypes.default.bool,
  grouped: _propTypes.default.bool,
  scrollToHideDataViewHeader: _propTypes.default.bool,
  toSelectionMap: _propTypes.default.bool,
  selectedItems: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.number]).isRequired,
  onSelectionChange: _propTypes.default.func,
  onItemMenu: _propTypes.default.func,
  onMenuClick: _propTypes.default.func,
  dataViewRenderer: _propTypes.default.func,
  itemsRenderer: _propTypes.default.func,
  getMoreData: _propTypes.default.func,
  onActiveChange: _propTypes.default.func,
  groupBy: _propTypes.default.func,
  getId: _propTypes.default.func,
  tileView: _propTypes.default.bool,
  onWheel: _propTypes.default.func,
  emptyState: _propTypes.default.shape({
    icon: _propTypes.default.object,
    label: _propTypes.default.string
  }),
  selectionMode: _propTypes.default.oneOf(['none', 'disabled', 'single', 'multi'])
});
(0, _defineProperty2.default)(DataView, "defaultProps", {
  tileView: false,
  data: [],
  onSelectionChange: () => {},
  getMoreData: () => {},
  onWheel: () => {}
});

/***/ }),

/***/ 17490:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = exports.ContextDataViewItem = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _context = __webpack_require__(14935);
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _list = __webpack_require__(70309);
var _itemdnd = _interopRequireDefault(__webpack_require__(40772));
var _flexlayout = _interopRequireWildcard(__webpack_require__(77765));
var _tile = _interopRequireDefault(__webpack_require__(42327));
var _container = _interopRequireDefault(__webpack_require__(32299));
var _truncatedtext = _interopRequireDefault(__webpack_require__(47511));
var _InputView = _interopRequireDefault(__webpack_require__(75878));
var _DataView = _interopRequireDefault(__webpack_require__(68803));
var _dataViewItem = _interopRequireDefault(__webpack_require__(75536));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const dataViewClassName = _DataView.default.dataView.replace(/"/g, '');
const dataViewItemClassName = _dataViewItem.default.dataViewItem.replace(/"/g, '');
const {
  BaPropTypes,
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
function createIcon(icon, locationClass) {
  if (!icon) {
    return null;
  }
  const iconComponent = typeof icon === 'string' ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    focusable: false,
    iconId: icon
  }) : icon;
  return locationClass ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _utils.classnames)(`${dataViewClassName}__icon`, locationClass)
  }, iconComponent) : iconComponent;
}
class DataViewItem extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_getDropProps", _ref => {
      let {
        id
      } = _ref;
      return {
        id
      };
    });
    (0, _defineProperty2.default)(this, "_onBeginDrag", _ref2 => {
      let {
        id,
        type,
        defaultName
      } = _ref2;
      return {
        id,
        type,
        defaultName
      };
    });
    (0, _defineProperty2.default)(this, "_canDrop", (target, source) => {
      if (target && source) {
        return target.id !== source.id;
      }
      return true;
    });
    (0, _defineProperty2.default)(this, "_onDrop", (target, source) => {
      const {
        onFileMove
      } = this.props;
      if (target && source) {
        const targetId = target && target.id;
        const sourceId = source && source.id;
        onFileMove && onFileMove({
          sourceId,
          targetId
        });
      }
    });
  }
  render() {
    const {
      dndable,
      disabled,
      readOnly,
      readable,
      writeable,
      traverseable,
      traversable,
      executable,
      className,
      style,
      ...others
    } = this.props;
    const listItemPassthroughProps = getInheritedProps(others, _list.ListItem);
    const listItemClassName = (0, _utils.classnames)(dataViewItemClassName, {
      disabled,
      readOnly,
      traverseable,
      traversable,
      readable,
      executable,
      writeable
    });
    const listItemProps = {
      ...sanitize(others, DataViewItem),
      ...listItemPassthroughProps,
      className: `${listItemClassName} ${className}`,
      style
    };
    if (dndable) {
      const DnDLisItem = (0, _itemdnd.default)(_list.ListItem, {
        dropItemType: 'DATAVIEW',
        dragItemType: 'DATAVIEW',
        simpleHoverStates: false
      });
      return /*#__PURE__*/_react.default.createElement(DnDLisItem, (0, _extends2.default)({
        getDropProps: this._getDropProps,
        onBeginDrag: this._onBeginDrag,
        canDrop: this._canDrop,
        onDrop: this._onDrop
      }, listItemProps), this.props.children);
    }
    return /*#__PURE__*/_react.default.createElement(_list.ListItem, (0, _extends2.default)({
      "data-tid": "ba-common-dataview-item"
    }, listItemProps), this.props.children);
  }
}

// eslint-disable-next-line react/forbid-foreign-prop-types
exports["default"] = DataViewItem;
(0, _defineProperty2.default)(DataViewItem, "Col", _ref3 => {
  let {
    icon,
    cols,
    content
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_container.default, {
    className: (0, _utils.classnames)(`${dataViewItemClassName}-container`, 'col')
  }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, null, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
    className: `${dataViewItemClassName}__icon `
  }, createIcon(icon)), cols.map((col, index) => /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
    key: index,
    grow: 1,
    className: `${dataViewItemClassName}__item `
  }, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
    value: content[col]
  })))));
});
(0, _defineProperty2.default)(DataViewItem, "Col2", _ref4 => {
  let {
    children,
    ...others
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_flexlayout.default, (0, _extends2.default)({
    className: (0, _utils.classnames)(`${dataViewItemClassName}-container`, 'col')
  }, others), children);
});
(0, _defineProperty2.default)(DataViewItem, "Cell", _ref5 => {
  let {
    children,
    grow,
    ...others
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, (0, _extends2.default)({
    grow: grow || 1,
    className: (0, _utils.classnames)(`${dataViewItemClassName}-container`, 'cell')
  }, others), children);
});
(0, _defineProperty2.default)(DataViewItem, "Tile", props => /*#__PURE__*/_react.default.createElement(_tile.default, props));
(0, _defineProperty2.default)(DataViewItem, "Label", _ref6 => {
  let {
    icon,
    title,
    subTitle,
    subTitleSecondary
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(_container.default, {
    className: (0, _utils.classnames)(`${dataViewItemClassName}-container`, 'label')
  }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, null, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
    className: (0, _utils.classnames)(`${dataViewItemClassName}__icon`)
  }, createIcon(icon)), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
    grow: 1,
    className: `${dataViewItemClassName}__content `
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${dataViewItemClassName}__title`
  }, title), /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
    direction: "row",
    justifyContent: "space-between",
    className: `${dataViewItemClassName}__content `
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${dataViewItemClassName}__subTitle`
  }, subTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: `${dataViewItemClassName}__subTitle`
  }, subTitleSecondary)))));
});
(0, _defineProperty2.default)(DataViewItem, "Input", _ref7 => {
  let {
    icon,
    ...props
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(_container.default, {
    className: (0, _utils.classnames)(`${dataViewItemClassName}-container`, 'label')
  }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, null, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
    className: (0, _utils.classnames)(`${dataViewItemClassName}__icon`)
  }, createIcon(icon)), /*#__PURE__*/_react.default.createElement(_InputView.default, props)));
});
(0, _defineProperty2.default)(DataViewItem, "propTypes", {
  ..._list.ListItem.propTypes,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  dndable: _propTypes.default.bool,
  traverseable: BaPropTypes.deprecated('It will be removed in Sprint 39.1, use "traversable" instead'),
  traversable: _propTypes.default.bool,
  readable: _propTypes.default.bool,
  executable: _propTypes.default.bool,
  writeable: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  onFileMove: _propTypes.default.func
});
(0, _defineProperty2.default)(DataViewItem, "defaultProps", {
  traversable: false,
  readOnly: false,
  disabled: false,
  readable: true,
  executable: true,
  writeable: true,
  className: '',
  style: {},
  onFileMove: () => {}
});
const ContextDataViewItem = exports.ContextDataViewItem = (0, _context.withContext)(...Object.keys(DataViewItem.propTypes))(DataViewItem);

/***/ }),

/***/ 75878:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _textinput = _interopRequireDefault(__webpack_require__(73346));
var _StringResource = _interopRequireDefault(__webpack_require__(32890));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

function getString(value) {
  return _StringResource.default.get(value);
}
class InputView extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      value: ''
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
    (0, _defineProperty2.default)(this, "_onBlur", () => {
      this.props.onSaveNewFile(this._node.props.value, this.props.fileType);
    });
    (0, _defineProperty2.default)(this, "_saveFIle", () => {
      this.props.onSaveNewFile(this._node.props.value, this.props.fileType);
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", event => {
      // enter
      switch (event.keyCode) {
        // enter
        case 13:
          {
            this._saveFIle();
            break;
          }
        // esc
        case 27:
          {
            this.props.dismissCreateFile();
            break;
          }
        default:
      }
    });
  }
  componentDidMount() {
    setTimeout(() => {
      this._node._input.inputNode.focus(); // eslint-disable-line no-underscore-dangle
    });
  }

  render() {
    const {
      getLocaleString,
      placeholder
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_textinput.default, {
      ref: this._ref,
      onKeyDown: this._onKeyDown,
      onBlur: this._onBlur,
      placeholder: placeholder || getLocaleString('placeholder')
      // autoFocus
      ,
      value: this.state.value,
      fullWidth: true,
      onChange: v => this.setState({
        value: v
      })
    });
  }
}
exports["default"] = InputView;
(0, _defineProperty2.default)(InputView, "propTypes", {
  ..._textinput.default.propTypes,
  onSaveNewFile: _propTypes.default.func,
  dismissCreateFile: _propTypes.default.func,
  fileType: _propTypes.default.string,
  getLocaleString: _propTypes.default.func,
  placeholder: _propTypes.default.string
});
(0, _defineProperty2.default)(InputView, "defaultProps", {
  dismissCreateFile: () => {},
  getLocaleString: getString
});

/***/ }),

/***/ 30987:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var _default = FallbackCom => Comp => {
  class components extends _react.Component {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false
      };
    }
    componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({
        hasError: true
      });
      // You can also log the error to an error reporting service
      console.error('something wrong happened; error:', error); // eslint-disable-line
      console.info('something wrong happened; info:', info); // eslint-disable-line
    }

    render() {
      if (FallbackCom && this.state.hasError) {
        return FallbackCom;
      }
      return /*#__PURE__*/_react.default.createElement(Comp, this.props);
    }
  }
  (0, _defineProperty2.default)(components, "propTypes", {
    children: _propTypes.default.any
  });
  components.WrappedComponent = Comp;
  return components;
};
exports["default"] = _default;

/***/ }),

/***/ 76929:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Navigator = _interopRequireDefault(__webpack_require__(89669));
exports["default"] = _Navigator.default;
exports.Navigator = _Navigator.default;
var _DataView = _interopRequireDefault(__webpack_require__(20069));
exports.DataView = _DataView.default;
var _DataViewItem = _interopRequireWildcard(__webpack_require__(17490));
exports.DataViewItem = _DataViewItem.default;
exports.ContextDataViewItem = _DataViewItem.ContextDataViewItem;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }

/***/ }),

/***/ 32890:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _NavigatorResources = _interopRequireDefault(__webpack_require__(45533));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_NavigatorResources.default);

/***/ }),

/***/ 3694:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-navigator .ba-common-dataview{flex-grow:1;flex-shrink:1;overflow:auto}.ba-navigator__header{width:100%;height:50px;display:inline-flex;justify-content:space-between;align-items:center;border-bottom-width:1px;border-bottom-style:solid}.ba-navigator__header .ba-common-toolbar{flex-wrap:nowrap !important;flex:0;-ms-flex:auto;width:100%;display:inline-flex}.ba-navigator__main{width:100%;height:calc(100% - 50px);display:flex;flex-direction:column;position:relative;overflow:hidden}.ba-navigator__main.is-noHeader{height:100%}.ba-navigator__card-container{display:flex;flex-wrap:wrap;padding-top:2rem}.ba-navigator__card-container .ba-card{width:49%;margin-right:1%;margin-top:1%}.ba-navigator__grid-container{padding-top:2rem}.ba-navigator__empty-state{height:100%;display:flex;justify-content:center;align-items:center}.ba-navigator__empty-state-icon{display:flex;justify-content:center;align-items:center;margin-bottom:.5em}.ba-navigator__dataview-header{height:48px}.ba-navigator__dataview-footer{height:auto}.ba-navigator{background-color:#fff}.ba-navigator__header{border-bottom-color:#e0e0e0}.ba-navigator__dataview-header.is-scrollable{transition:margin .2s ease-in-out}", ""]);

// exports
exports.locals = {
	"navigatorClassName": "\"ba-navigator\""
};

/***/ }),

/***/ 55452:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-dataview{width:100%;height:100%;position:relative}.ba-common-dataview__empty-state{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.ba-common-dataview__empty-state-container{display:flex;flex-direction:column;align-items:center}.ba-common-dataview__empty-state-icon{display:flex;justify-content:center;align-items:center;margin-bottom:.5em;opacity:.5}.ba-common-dataview__loading{height:100%;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center}.ba-common-dataview__groupedLabel{margin-top:1rem}.ba-common-dataview__groupedLabel.ba-common-label{font-size:1rem}.ba-common-dataview .is-multiSelecting .ba-common-listItem .ba-common-listItem__cmBtn{visibility:hidden}.ba-common-dataview .is-tileView.ba-common-list>div{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper:nth-child(2n-1) .ba-common-dataviewItem.ba-common-listItem{margin-right:0}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper.is-groupedLabel{width:100%;pointer-events:none}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper.is-groupedLabel .ba-common-listItem:hover{background:transparent}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem{padding:0;margin-right:32px;margin-bottom:24px;border:none;max-height:100%}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem.is-selected{border:none}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem.is-traversable .ba-common-flexLayout-item.ba-common-listItem__cmBtn{position:absolute;top:0;right:8px;bottom:0;margin:auto;display:flex}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem .ba-common-flexLayout-item.ba-common-listItem__cmBtn{position:absolute;right:16px;bottom:9px}.ba-common-dataview__menuContainer.ba-theme-default.ba-common-container{transition:none;z-index:9001}.ba-common-dataview.is-rowView.ba-common-listItem{border-top-color:#c0bfc0}.ba-common-dataview.is-rowView .ba-common-dataview__item--date,.ba-common-dataview.is-rowView .ba-common-dataview__item--ellipsis,.ba-common-dataview.is-rowView .ba-common-dataview__item--quality{color:#c0bfc0}.ba-common-dataview.is-tileView .ba-common-dataview__content{border-color:#eaeaea}.ba-common-dataview.is-tileView .ba-common-dataview__content:hover{border-color:#c0bfc0}.ba-common-dataview.is-tileView .ba-common-dataview__description__type{color:#949394}.ba-common-dataview.is-tileView .ba-common-dataview__description__name{color:#343334}.ba-common-dataview.is-tileView .ba-common-dataview__description__footer{color:#949394}", ""]);

// exports
exports.locals = {
	"dataView": "\"ba-common-dataview\""
};

/***/ }),

/***/ 84407:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-dataviewItem__subTitle{font-size:.75rem;font-weight:400;line-height:1rem}.ba-common-dataviewItem{padding-left:16px;min-height:48px;max-height:48px;position:relative}.ba-common-dataviewItem:after{content:\"\";width:100%;border-bottom-width:thin;border-bottom-style:solid;position:absolute;bottom:0px;left:0}.ba-common-dataviewItem-container{width:100%}.ba-common-dataviewItem-container.is-cell{display:flex;justify-content:center;align-items:center}.ba-common-dataviewItem__icon{display:flex;justify-content:center;align-items:center;padding-right:1em}.ba-common-dataviewItem__item{font-size:1rem;line-height:1.125rem}.ba-common-dataviewItem:after{border-color:#eaeaea}.ba-common-dataviewItem.is-focus:after{border-color:transparent}.ba-common-dataviewItem__subTitle{color:#595859}", ""]);

// exports
exports.locals = {
	"dataViewItem": "\"ba-common-dataviewItem\""
};

/***/ }),

/***/ 32547:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3694);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Navigator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 68803:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55452);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_DataView_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 75536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84407);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_dataViewItem_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 32737:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/add_32");

/***/ }),

/***/ 75924:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrows--vertical_32");

/***/ }),

/***/ 20361:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/filter-applied_16");

/***/ }),

/***/ 95333:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/filter_16");

/***/ }),

/***/ 16346:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32");

/***/ }),

/***/ 76214:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/search_16");

/***/ }),

/***/ 5158:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/settings--adjust_32");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 68393:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__68393__;

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 32299:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32299__;

/***/ }),

/***/ 14935:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__14935__;

/***/ }),

/***/ 66740:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__66740__;

/***/ }),

/***/ 77765:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__77765__;

/***/ }),

/***/ 40772:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__40772__;

/***/ }),

/***/ 37394:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37394__;

/***/ }),

/***/ 85717:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__85717__;

/***/ }),

/***/ 70309:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__70309__;

/***/ }),

/***/ 93158:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__93158__;

/***/ }),

/***/ 3142:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3142__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 73346:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__73346__;

/***/ }),

/***/ 42327:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__42327__;

/***/ }),

/***/ 84368:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__84368__;

/***/ }),

/***/ 47511:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__47511__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(76929));
/******/ return __webpack_exports__;
/******/ }
]);
});